<template>
  <div>
    <div class="btn">
      <!-- <el-button class="btn-print" @click="handleDown()">导出PDF</el-button> -->
      <!-- <el-button class="btn-print" @click="handleDown2()">导出Word</el-button> -->
      <!-- <el-button class="btn-print" @click="handleDown3()">打印</el-button> -->
    </div>
    <div id="pdfDom">
      <h2 style="margin-left:30%">质量安全事项督办令</h2>
      <table class="table" style="border: 0.5px solid black;">
        <tr>
          <td style="border: 0.5px solid black;width: 150px;font-size: 15px;color: #333;text-align: center;">专业化公司</td>
          <td style="border: 0.5px solid black;width: 150px;font-size: 15px;color: #333;text-align: center;">{{dataObj.companyName}}</td>
          <td style="border: 0.5px solid black;width: 150px;font-size: 15px;color: #333;text-align: center;">单位名称</td>
          <td style="border: 0.5px solid black;width: 150px;font-size: 15px;color: #333;text-align: center;">{{dataObj.qyName}}</td>
        </tr>
        <tr>
          <td style="border: 0.5px solid black;width: 150px;font-size: 15px;color: #333;text-align: center;">事项名称</td>
          <td style="border: 0.5px solid black;width: 150px;font-size: 15px;color: #333;text-align: center;" colspan="3">{{dataObj.superviseDesr}}</td>
        </tr>
        <tr>
          <td style="border: 0.5px solid black;width: 150px;font-size: 15px;color: #333;text-align: center;">事项类型</td>
          <td style="border: 0.5px solid black;width: 150px;font-size: 15px;color: #333;text-align: center;" colspan="3">{{dataObj.superviseType}}</td>
        </tr>
         <tr>
          <td style="border: 0.5px solid black;width: 150px;font-size: 15px;color: #333;text-align: center;">限期完成时间</td>
          <td style="border: 0.5px solid black;width: 150px;font-size: 15px;color: #333;text-align: center;" colspan="3">以整改方案为准</td>
        </tr>
         <tr>
          <td style="border: 0.5px solid black;width: 150px;font-size: 15px;color: #333;text-align: center;">重大事项内容及影响程度</td>
          <td style="border: 0.5px solid black;width: 150px;font-size: 15px;color: #333;text-align: center;" colspan="3">{{dataObj.superviseInfluence}}</td>
        </tr>
        <tr>
          <td style="border: 0.5px solid black;width: 150px;font-size: 15px;color: #333;text-align: center;">处置要求及验收标准</td>
          <td colspan="3" style="border: 0.5px solid black;width: 150px;font-size: 15px;color: #333;text-align: center;">
             <!-- 单行居中，多行居左显示。 -->
            <span style="display: inline-block;text-align: left;">
              {{dataObj.superviseStandard}}
            </span>
          </td>
        </tr>
         <tr>
          <td style="border: 0.5px solid black;width: 150px;font-size: 15px;color: #333;text-align: center;">督办负责人</td>
          <td style="border: 0.5px solid black;width: 150px;font-size: 15px;color: #333;text-align: center;">{{dataObj.superviseUserName}}</td>
          <td style="border: 0.5px solid black;width: 150px;font-size: 15px;color: #333;text-align: center;">联系电话</td>
          <td style="border: 0.5px solid black;width: 150px;font-size: 15px;color: #333;text-align: center;">{{dataObj.telphoneNum}}</td>
        </tr>
        <tr>
          <td style="border: 0.5px solid black;width: 150px;font-size: 15px;color: #333;text-align: center;">传真</td>
          <td style="border: 0.5px solid black;width: 150px;font-size: 15px;color: #333;text-align: center;">{{dataObj.fax}}</td>
          <td style="border: 0.5px solid black;width: 150px;font-size: 15px;color: #333;text-align: center;">电子邮箱</td>
          <td style="border: 0.5px solid black;width: 150px;font-size: 15px;color: #333;text-align: center;">{{dataObj.email}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import htmlToPdf from '@/assets/js/htmlToPdf.js'
import Print from '@/assets/js/print.js'
import "@/assets/js/jquery.wordexport.js"
import htmlToDocx from  "@/assets/js/htmlDocx.js"
export default {
  props: {
    editContent: {
      type: String,
      default: () => {
        return ""
      },
    },
    wordTitle: {
      type: String,
      default: () => {
        return ""
      },
    },
    wordData:Object,
  },
  data(){
    return{
      dataObj:{}
    }
  },
  methods:{
    	handleDown() {
				//导出PDF
				htmlToPdf.downloadPDF(document.querySelector('#pdfDom'), '中粮集团质量安全重大事项督办令');
      },
      handleDown2(){
         this.$nextTick(() => {
        // $('#pdfDom').wordExport('中粮集团质量安全重大事项督办令')//
        htmlToDocx.exportDocx(document.querySelector('#pdfDom'),//
         '质量安全事项督办令',
          {
              margins: { top: 150 }
           }
        )
        }, 500);
      },
      handleDown3(){
        // Print.Print(document.querySelector('#pdfDom','中粮集团质量安全重大事项督办令'))
        // 使用事例
      },
      getOne(){

      },
  },
  watch:{
   wordData(val,oldVal){
     if(Object.keys(val).length > 0){
       this.dataObj=val;
     }
   }
  }
}
</script>

<style scoped>
.btn{
  display:flex;
}
	@media only screen {
		.btn-print {
			display: block
		}
	}
</style>